/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import './ValetInstructionsV1.scss';
import { AudioPlayer, Modal } from '../../../../UiKit';
import { AddInstructions } from '../../../commons';
import EditValetInstruction from './EditValetInstruction';
import { Check, CheckCheck } from 'lucide-react';
import Button from '../../../ComponentsV1/Button';
import { InstructionsImagesV1 } from '../OrderRiderImages/OrderRiderImagesV1';
import { ToolTip } from '../../../ComponentsV1/ToolTip/Tooltip';

export default class ValetInstructionsV1 extends Component {
  render() {
    const { order } = this.props;
    return (
      <div className='valetInstructionContainerV1 tw-h-full'>
        {!order ? (
          <Shimmer height='120px' width='100%' />
        ) : (
          <ValetInstructionsComp {...this.props} />
        )}
      </div>
    );
  }
}

class ValetInstructionsComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTextBoxOpen: false,
      isEditInstructionOpen: false,
      openInstructionsModal: false,
    };
  }

  checkIfTextBoxIsOpen = (isTextBoxOpen) => {
    this.setState({
      isTextBoxOpen: isTextBoxOpen,
    });
  };

  handleInstructionModal = () => {
    let prevState = this.state.isEditInstructionOpen;
    this.setState({
      isEditInstructionOpen: !prevState,
    });
  };

  handleInstructionsClick = () => {
    this.setState({
      openInstructionsModal: !this.state.openInstructionsModal,
    });
  };

  render() {
    const { order } = this.props.order;
    if (!order) return null;
    const {
      valet_instruction_seen,
      address_instruction,
      audio_instruction,
      delivery_instruction = [],
    } = order;
    const { isEditInstructionOpen } = this.state;

    let deliveryInstructionsString = '';

    if (delivery_instruction) {
      delivery_instruction.map((item) => {
        deliveryInstructionsString = deliveryInstructionsString + item + ' , ';
      });
      deliveryInstructionsString = deliveryInstructionsString.replace(
        /,\s*$/,
        '',
      );
    }

    return (
      <div className='tw-flex tw-h-full tw-w-full tw-flex-col tw-justify-between'>
        <div className='tw-flex tw-flex-col tw-w-full tw-gap-2'>
          <div className='tw-text-300 tw-font-medium tw-flex tw-items-center tw-justify-between tw-w-full'>
            <div className='tw-flex tw-items-center tw-text-zinc-500 tw-leading-none tw-h-5'>
              <span
                className='tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer'
                onClick={this.handleInstructionsClick}
              >
                Rider Instructions
              </span>
              {/* Instructions seen status */}
              <ToolTip
                placement='bottom'
                content={
                  valet_instruction_seen
                    ? 'Instructions seen by Valet'
                    : 'Instructions sent to Valet'
                }
              >
                <div
                  className={`tw-rounded-lg tw-p-px ${
                    valet_instruction_seen
                      ? 'tw-bg-green-200/50'
                      : 'tw-bg-grey-100 tw-border tw-border-solid tw-border-grey-200/70'
                  } tw-ml-2`}
                >
                  {valet_instruction_seen ? (
                    <CheckCheck size={14} color='#318616' />
                  ) : (
                    <Check size={14} />
                  )}
                </div>
              </ToolTip>
            </div>
          </div>
        </div>

        <Modal
          isVisible={this.state.openInstructionsModal}
          padding={0}
          paddingTop={'0rem'}
          type='large'
          maxHeight='80vh'
          containerStyles={{ margin: '16px 0 0px 0', padding: '0 20px' }}
          titleComponent={
            <span className='tw-text-[1.8rem] tw-font-medium tw-text-zinc-700'>
              Rider Instructions
            </span>
          }
          handleClose={this.handleInstructionsClick}
        >
          <div className='tw-flex tw-flex-col tw-justify-between'>
            <div className='tw-flex tw-items-center tw-gap-4 tw-leading-none tw-ml-2'>
              {/* delivery instruction */}
              {delivery_instruction && (
                <div className='tw-flex tw-flex-col tw-items-start tw-gap-2'>
                  <div className='tw-text-[1.7rem] tw-font-medium tw-text-zinc-600'>
                    Instructions
                  </div>
                  <p className='tw-text-[1.6rem] tw-font-medium tw-text-zinc-500'>
                    {deliveryInstructionsString}
                  </p>
                  {audio_instruction && <AudioPlayer src={audio_instruction} />}
                </div>
              )}
            </div>

            {order?.order_id && !order?.is_live && (
              <InstructionsImagesV1
                orderId={order?.order_id}
                getImages={this.state.openInstructionsModal}
              />
            )}

            {/* Instructions Actions */}
            <div className='tw-flex tw-justify-end tw-w-full tw-gap-2 tw-items-center tw-mt-4'>
              {/* Edit instructions */}
              {order?.is_live && (
                <Button
                  onClick={this.handleInstructionModal}
                  title={'Edit Instructions'}
                  type='secondary'
                />
              )}
              {/* Add Instructions */}
              {order.delivery_instruction_allowed && (
                <AddInstructions
                  oldInstruction={address_instruction}
                  orderId={order?.order_id}
                  target='delivery'
                  updateaInstruction={this.props.retry}
                  checkIfTextBoxIsOpen={this.checkIfTextBoxIsOpen}
                />
              )}
            </div>
          </div>

          {isEditInstructionOpen && order?.order_id && (
            <EditValetInstruction
              isEditInstructionOpen={isEditInstructionOpen}
              closeModal={this.handleInstructionModal}
              orderId={order?.order_id}
              refetchInstruction={this.props.retry}
            />
          )}
        </Modal>
      </div>
    );
  }
}
